import AutoPaySetDialog from './AutoPaySetDialog'
export default AutoPaySetDialog
